module.exports = __webpack_public_path__ + "img/1516880111.22cd776d.jpg";